import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

// Entity pages that should be reported to the chatbot as the "current view".
// entityType?: 'lead' | 'account' | 'deal' | 'contact' | 'case'
const SET_CHAT_CURRENT_VIEW = 'SET_CHAT_CURRENT_VIEW';
const CLEAR_CHAT_CURRENT_VIEW = 'CLEAR_CHAT_CURRENT_VIEW';

const setChatCurrentView = (entityType, entityId) => ({
    type: SET_CHAT_CURRENT_VIEW,
    payload: { entityType, entityId },
});
const clearChatCurrentView = () => ({ type: CLEAR_CHAT_CURRENT_VIEW });

const initialState = { currentView: null };

const chatCurrentViewReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_CHAT_CURRENT_VIEW:
            return { ...state, currentView: action.payload };
        case CLEAR_CHAT_CURRENT_VIEW:
            return { ...state, currentView: null };
        default:
            return state;
    }
};

/**
 * Call inside an entity form/detail page with the record id held in that page.
 * While the id is set (record opened) the chatbot sends currentView;
 * when the id is empty (new record / list) or the page unmounts, it is cleared.
 */
const useChatCurrentView = (entityType, entityId) => {
    const dispatch = useDispatch();
    useEffect(() => {
        const id = Number(Array.isArray(entityId) ? entityId[0] : entityId);
        if (Number.isFinite(id) && id > 0) {
            dispatch(setChatCurrentView(entityType, id));
        } else {
            dispatch(clearChatCurrentView());
        }
    }, [entityType, entityId, dispatch]);
    useEffect(() => () => { dispatch(clearChatCurrentView()); }, [dispatch]);
};

export { setChatCurrentView, clearChatCurrentView, chatCurrentViewReducer, useChatCurrentView };